import store from '@/store';
import mixpanel from 'mixpanel-browser';
export const useMixpanelOtoAcademy = (pageViewName) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
    });
};
export const useMixpanelOpenModal = (pageViewName, userExists, nameButton) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
        userExists,
        nameButton,
    });
};
export const useMixpanelClickAccess = (pageViewName, modal) => {
    mixpanel.track(pageViewName, {
        user: store?.getters?.user?.id,
        brand: store?.getters?.selectedBrand?.brand,
        modal,
    });
};
